/* ============================================================================
   Analytics settings. Values come from .env (build time):

     REACT_APP_GA_MEASUREMENT_ID      GA4 web stream ID, e.g. G-ABC123XYZ.
                                      Empty = analytics and the cookie banner are off.
     REACT_APP_APPLE_PROVIDER_TOKEN   App Store Connect provider token ("pt") for
                                      App Store campaign links. Optional.

   See docs/ANALYTICS.md for the full picture.
   ========================================================================== */

export const GA_MEASUREMENT_ID = (process.env.REACT_APP_GA_MEASUREMENT_ID || "").trim();
export const APPLE_PROVIDER_TOKEN = (process.env.REACT_APP_APPLE_PROVIDER_TOKEN || "").trim();

export const ANALYTICS_ENABLED = /^G-[A-Z0-9]+$/.test(GA_MEASUREMENT_ID);

/* Pages that are never tracked (and never show the cookie banner). */
export const isUntrackedPath = (pathname) => pathname.startsWith("/admin") || pathname === "/login";

/* Bump when the banner text / purpose changes, so everyone is asked again. */
export const CONSENT_VERSION = 1;
